import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'sas-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

}
